import images from "../constants/images";
import { useParams } from "react-router-dom";
import Clickable from "../components/clickable.";
import Page from "../components/page";
import * as Yup from "yup";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import api from "../functions/api";
import Webcam from "react-webcam";
import moment from "moment";
import toast from "../functions/toast";

const Details = () => {
    const [employee, setEmployee] = useState();

    const [showCamera, setShowCamera] = useState(false);
    const [photo, setPhoto] = useState(null);

    let { data } = useParams();

    data = JSON.parse(atob(data));

    const shift = () => {
        const currentHour = new Date().getHours();
        return currentHour >= 9 && currentHour < 22 ? 0 : 1;
    };

    const capturePhoto = (webcamRef) => {
        if (webcamRef && webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot();
            setPhoto(imageSrc);
            setShowCamera(false);
        }
    };

    const webcamRef = React.useRef(null);

    const videoConstraints = {
        facingMode: "environment",
    };

    const signUpSchema = Yup.object({
        username: Yup.string().required("Please enter your Username"),
        production: Yup.number()
            .typeError("Please enter only number")
            .required("Please enter your Production"),
        frame: Yup.number()
            .typeError("Please enter only number")
            .required("Please enter your Frame"),
        dhaga: Yup.number()
            .typeError("Please enter only number")
            .required("Please enter your Dhaga"),
    });

    const initialValues = {
        username: null,
        production: null,
        frame: null,
        dhaga: null,
    };

    const { errors, values, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: signUpSchema,
            onSubmit: (values, action) => {
                addAttendace();
                action.resetForm();
                setPhoto(null);
            },
        });

    const getEmployees = async () => {
        try {
            const _data = await api.get(`/employees?admin=${data.admin}`);
            setEmployee(_data);
        } catch (err) {
            console.log("🚀 ~ getEmployees ~ err:", err);
        }
    };

    const addAttendace = async () => {
        try {
            await api.post("/add-attendance", {
                photo,
                employee: values.username,
                shift: shift(),
                machine: data._id,
                production: values.production,
                frame: values.frame,
                dhaga: values.dhaga,
            });
            toast.success(`Attendance submited successfully`);
        } catch (err) {
            console.log("��� ~ addAttendace ~ err:", err);
        }
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    };

    const handleCancel = () => {
        window.location.reload();
    };

    useEffect(() => {
        getEmployees();
    }, []);

    return (
        <Page hideBottom className="details" title="Details">
            <div className="details-user" onSubmit={handleSubmit}>
                <div className="e-name-drop">
                    <div className="person">
                        <img src={images.machine} className="person-icon" />
                        <label>Machine Name</label>
                    </div>

                    <div name="machinename" className="select">
                        {`${data?.head}/${data?.area} ${data?.name}`}
                    </div>
                </div>

                <div className="e-name-drop">
                    <div className="person">
                        <img src={images.person} className="person-icon" />
                        <label>Employee Name</label>
                    </div>
                    <select
                        name="username"
                        value={values.username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option disabled selected>
                            Select an employee
                        </option>
                        {employee?.map((item, index) => (
                            <option value={item._id} key={index}>
                                {item?.name}
                            </option>
                        ))}
                    </select>
                    {errors.username && touched.username && (
                        <p className="form-error">{errors.username}</p>
                    )}
                </div>

                <div className="e-name-drop">
                    <div className="person">
                        <img src={images.time} className="person-icon" />
                        <label>Shift</label>
                    </div>

                    <select name="shift" value={shift()} disabled>
                        <option value="" disabled hidden>
                            Select an Shift
                        </option>
                        <option value={0}>Day</option>
                        <option value={1}>Night</option>
                    </select>
                </div>

                <div className="e-name-drop">
                    <div className="person">
                        <img src={images.date} className="person-icon" />
                        <label>Date</label>
                    </div>
                    <input
                        className="product"
                        placeholder="Production"
                        type="Date"
                        disabled
                        value={moment(new Date()).format("YYYY-MM-DD")}
                    />
                </div>

                <div className="e-name-drop">
                    <div className="person">
                        <img src={images.factory} className="person-icon" />
                        <label>Production</label>
                    </div>
                    <input
                        className="product"
                        placeholder="Production"
                        value={values.production}
                        onChange={handleChange("production")}
                        onBlur={handleBlur("production")}
                        inputMode="numeric"
                    />
                    {errors.production && touched.production && (
                        <p className="form-error">{errors.production}</p>
                    )}
                </div>

                <div className="e-name-drop">
                    <div className="person">
                        <img src={images.frame} className="person-icon" />
                        <label>Frame</label>
                    </div>
                    <input
                        className="product"
                        placeholder="Frame"
                        value={values.frame}
                        onChange={handleChange("frame")}
                        onBlur={handleBlur("frame")}
                        inputMode="numeric"
                    />
                    {errors.frame && touched.frame && (
                        <p className="form-error">{errors.frame}</p>
                    )}
                </div>

                <div className="e-name-drop">
                    <div className="person">
                        <img src={images.dhaga} className="person-icon" />
                        <label>Dhaga</label>
                    </div>
                    <input
                        className="product"
                        placeholder="Dhaga"
                        value={values.dhaga}
                        onChange={handleChange("dhaga")}
                        onBlur={handleBlur("dhaga")}
                        inputMode="numeric"
                    />
                    {errors.dhaga && touched.dhaga && (
                        <p className="form-error">{errors.dhaga}</p>
                    )}
                </div>

                <div className="e-name-drop">
                    <div
                        className="camera-icon"
                        onClick={() => setShowCamera(true)}
                    >
                        <img
                            src={images.camera}
                            className="person-icon"
                            alt="Camera Icon"
                        />
                        <label>Catcher Photo</label>
                    </div>
                    {/* <input
                        className="product"
                        placeholder="Photos"
                        value={photo || values.photos}
                        onChange={handleChange("photos")}
                        onBlur={handleBlur("photos")}
                    /> */}

                    {showCamera && (
                        <div className="camera-container">
                            <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                videoConstraints={videoConstraints}
                                className="camera"
                            />
                            <div className="camera-btn">
                                <Clickable
                                    className="save-b"
                                    onClick={() => capturePhoto(webcamRef)}
                                >
                                    Capture
                                </Clickable>
                                <Clickable
                                    className="cancel-b"
                                    onClick={() => setShowCamera(false)}
                                >
                                    Close
                                </Clickable>
                            </div>
                        </div>
                    )}
                </div>

                {photo && (
                    <img
                        src={photo}
                        style={{
                            width: 200,
                            marginTop: 10,
                        }}
                    />
                )}
            </div>

            <div className="save-button">
                <Clickable className="cancel-b" onClick={handleCancel}>
                    <img src={images.close} className="cancel-icon" />
                    Cancel
                </Clickable>
                <Clickable
                    className="save-b"
                    onClick={handleSubmit}
                    disabled={!photo}
                >
                    <img src={images.save} className="cancel-icon" />
                    Save
                </Clickable>
            </div>
        </Page>
    );
};

export default Details;
